<script>
export default {
    name: "OrderPreview",

    data() {

        return {
            transfereddetails: {
                memo: ``,
                isApproved: false,
                userName: this.$root.username,
            },
        };
    },

    props: {
        showModal: Boolean,
         order: {
            type: Object,
            required: true,
        },
        transferdetails: {
            type: Object,
            required: true,
        },
        transferedItems: {
            type: Array,
            required: true,
        },
        decline: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        
    },

    methods: {

        

        printOrder() {
            let url = `/inventory-management/orders/printTransfer/${this.order.transferCode}`;
 
            window.open(url, `_blank`, `OrderPrint`);
        },
    }
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-4/5 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">
        Approved Tansfer - {{ order.transferCode }} 
         </h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap bg-gray-300 p-2">
            <div class="flex-1">
                <h5 class="font-medium text-sm">Date: {{ order.date | dateFormat }}</h5>
            </div>
           
            <div class="flex-1">
                <h5 class="font-medium text-sm">Store From: {{ order.storeFrom }}</h5>
            </div> <div class="flex-1">
                <h5 class="font-medium text-sm">Store To: {{ order.storeTo }}</h5>
            </div>
            
        </div>
        <div class="w-full overflow-auto my-2">
            <table class="table">
                <thead class="bg-blue-500 text-white text-xs">
                    <tr>
                        
                        <th class="p-tiny border">Item</th>
                        <th class="p-tiny border">Qty</th>
                        <th class="p-tiny border">Description</th>
                        <th class="p-tiny border">User</th> 
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="orderItem in transferedItems" :key="orderItem.requisitionDetailID">
                         <td class="p-tiny">{{ orderItem.itemName }}</td>
                        <td class="p-tiny">{{ orderItem.qty }}</td>
                         <td class="p-tiny">{{ orderItem.description }}</td>
                        <td class="p-tiny">{{ orderItem.userName}}</td>
                        </tr>
                     
                </tbody>
            </table>
        </div>
         
        <div  class="md:w-2/3 w-full p-1">
            <label for="grid-approval-memo" class="label-control">Approval Memo:</label>
              {{order.approvalMemo?order.approvalMemo:'-'}}
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <div class="w-full flex flex-wrap">
        <div class="md:w-2/3 w-full"></div>
        <div class="flex-1 p-1 text-right">
            <button 
                class="btn-danger btn-sm text-xs rounded mr-5" 
                @click.prevent="$emit(`closeModal`)">
                    <i class="fa fa-times"></i> Close</button>
            <button
                @click.prevent="printOrder"
                class="btn-info btn-sm text-xs rounded">
                    <i class="fa fa-print"></i> Print</button>
        </div>
    </div>
  </template>
</tail-modal>
</template>
